var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import React from 'react';
export const AccountBadgeSlideoutTooltip = styled((_a) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement(Tooltip, Object.assign({}, props, { classes: { popper: className } })));
})(() => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: themeColors.overlay.inverse,
        color: themeColors.text.inverse,
        paddingX: 1,
        paddingY: 0.5,
        lineHeight: 1,
        fontSize: 12,
        textAlign: 'center',
        fontWeight: 400,
    },
}));
